import React, { useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';

const CertificatesMain = () => {
  const [selectedCert, setSelectedCert] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [language, setLanguage] = useState('en');
  const [searchTerm, setSearchTerm] = useState('');

const certificates = [
  {
    id: 1,
    title: 'Punjab Blood Transfusion Authority',
    title_ur: 'پنجاب بلڈ ٹرانسفیوژن اتھارٹی',
    description: 'Punjab Blood Transfusion Authority Certificate is an official document issued by the Punjab Blood Transfusion Authority (PBTA) to licensed blood banks, hospitals, or laboratories. It certifies that the facility complies with the safety, quality, and regulatory standards set by the Authority for the collection, screening, storage, and transfusion of blood and blood products.',
    description_ur: 'پنجاب بلڈ ٹرانسفیوژن اتھارٹی سرٹیفکیٹ ایک سرکاری دستاویز ہے جو پنجاب بلڈ ٹرانسفیوژن اتھارٹی (PBTA) کی جانب سے منظور شدہ بلڈ بینکس، اسپتالوں یا لیبارٹریز کو جاری کی جاتی ہے۔ یہ سرٹیفکیٹ اس بات کی تصدیق کرتا ہے کہ متعلقہ ادارہ خون کے عطیات، جانچ، محفوظ ذخیرہ، اور منتقلی کے عمل میں اتھارٹی کے مقرر کردہ حفاظتی اور معیاری اصولوں پر عمل کر رہا ہے۔',
    image: process.env.PUBLIC_URL + '../assets/img/certificates/PBTA_Certificate.pdf',
    date: '2025-04-09'
  },
  {
    id: 2,
    title: 'EQAS External Quality Assurance Services',
    title_ur: 'EQAS بیرونی کوالٹی ایشورنس سروسز',
    description: 'EQAS (External Quality Assurance Services) is a quality assessment program designed to evaluate and improve the accuracy and reliability of laboratory testing by comparing a lab’s performance against established standards and peer laboratories. It ensures consistent, high-quality results through regular proficiency testing and external audits.',
    description_ur: 'EQAS (ایکسٹرنل کوالٹی ایشورنس سروسز) ایک معیاری جانچ کا نظام ہے جو لیبارٹری ٹیسٹوں کی درستگی اور قابل اعتماد نتائج کو جانچنے اور بہتر بنانے کے لیے استعمال ہوتا ہے۔ اس کا مقصد لیبارٹری کی کارکردگی کو قومی یا بین الاقوامی معیار کے مطابق جانچنا ہوتا ہے، تاکہ مریضوں کو معیاری اور درست تشخیص فراہم کی جا سکے۔',
    image: process.env.PUBLIC_URL + '../assets/img/certificates/eqas-24-25.pdf',
    date: '2023-07-22'
  },
   {
    id: 3,
    title: 'Memorandum of Understanding - PANAH ',
    title_ur: 'EQAS بیرونی کوالٹی ایشورنس سروسز',
    description: 'A milestone was achieved for needy and deserving patient by signing MOU between Rawalpindi Institute of Cardiology & Pakistan National Heart Association, through this platform needy patient can avail sponsorship for operations and cardiac treatment at RIC.',
    description_ur: 'In Urdu',
    image: process.env.PUBLIC_URL + '../assets/img/certificates/PANAH-Certificate.pdf',
    date: '2025-09-14'
  }
];


  const filteredCertificates = certificates.filter(cert =>
    cert.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    cert.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const openModal = (cert, index) => {
    setSelectedCert(cert);
    setCurrentIndex(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedCert(null);
    setShowModal(false);
  };

  const downloadFile = (url, title) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = `${title}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const printCert = () => {
    const content = document.getElementById('print-area');
    const win = window.open('', '_blank');
    win.document.write(`<html><body>${content.innerHTML}</body></html>`);
    win.document.close();
    win.print();
  };

  const swipeNext = () => {
    const nextIndex = (currentIndex + 1) % filteredCertificates.length;
    openModal(filteredCertificates[nextIndex], nextIndex);
  };

  const swipePrev = () => {
    const prevIndex = (currentIndex - 1 + filteredCertificates.length) % filteredCertificates.length;
    openModal(filteredCertificates[prevIndex], prevIndex);
  };

  return (
    <main className="bg-white">
      <Breadcrumb title="Our Certifications" />

      <div className="container py-5">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
          <h4 className="fw-semibold">Explore Our Hospital Certificates</h4>
          <div className="d-flex gap-2">
            <select className="form-select w-auto" value={language} onChange={e => setLanguage(e.target.value)}>
              <option value="en">English </option>
              <option value="ur">اردو </option>
            </select>
            <input
              type="text"
              className="form-control w-auto"
              placeholder="Search..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="row g-4">
          {filteredCertificates.map((cert, index) => (
          <div className="col-md-4" key={cert.id}>
                <div className="card h-100 shadow border-0 rounded-4">
                    <div className="cert-img-wrapper">
                    {cert.image.endsWith('.pdf') ? (
                        <embed src={cert.image} type="application/pdf" className="cert-img" />
                    ) : (
                        <img src={cert.image} alt={cert.title} className="cert-img" />
                    )}
                    </div>
                    <div className="card-body d-flex flex-column">
                    <h5 className="text-primary">{language === 'en' ? cert.title : cert.title_ur}</h5>
                    <p className="flex-grow-1">{language === 'en' ? cert.description : cert.description_ur}</p>
                    <p className="text-muted small">
                        <i className="bi bi-calendar-event"></i> {cert.date}
                    </p>
                    <div className="d-flex justify-content-between mt-3">
  <button className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1" onClick={() => openModal(cert, index)}>
    <i className="bi bi-eye"></i> View
  </button>
  <button className="btn btn-outline-success btn-sm d-flex align-items-center gap-1" onClick={() => downloadFile(cert.image, cert.title)}>
    <i className="bi bi-download"></i> Download
  </button>
</div>
                    </div>
                </div>
                </div>

          ))}
        </div>
      </div>

      {showModal && selectedCert && (
        <div className="custom-modal-overlay" onClick={closeModal}>
          <div className="custom-modal-content" onClick={e => e.stopPropagation()}>
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
              <button className="btn btn-light" onClick={swipePrev}>← Prev</button>
              <h5 className="text-white mb-0">{language === 'en' ? selectedCert.title : selectedCert.title_ur}</h5>
              <button className="btn btn-light" onClick={swipeNext}>Next →</button>
            </div>
            <div id="print-area">
              {selectedCert.image.endsWith('.pdf') ? (
                <embed src={selectedCert.image} type="application/pdf" className="modal-image" />
              ) : (
                <img src={selectedCert.image} alt={selectedCert.title} className="modal-image rounded shadow" />
              )}
            </div>
           <div className="mt-3 d-flex justify-content-center gap-3 flex-wrap">
  <button className="btn btn-outline-light d-flex align-items-center gap-1" onClick={() => downloadFile(selectedCert.image, selectedCert.title)}>
    <i className="bi bi-download"></i> Download
  </button>
  <button className="btn btn-outline-warning d-flex align-items-center gap-1" onClick={printCert}>
    <i className="bi bi-printer"></i> Print
  </button>
  <button className="btn-close-white btn-close" onClick={closeModal}></button>
</div>

          </div>
        </div>
      )}
<style>{`
  .cert-img-wrapper {
    width: 100%;
    padding: 1rem;
    background: #f0f4f8;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .cert-img-wrapper embed,
  .cert-img-wrapper img {
    width: 100%;
    height: auto;
    max-height: 250px;
    object-fit: contain;
    border-radius: 0.5rem;
    transition: transform 0.3s ease;
  }

  .card {
    transition: transform 0.2s ease, box-shadow 0.3s ease;
    border-radius: 1rem;
  }

  .card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  }

  .card-body h5 {
    font-weight: 600;
    font-size: 1.1rem;
  }

  .card-body p {
    font-size: 0.9rem;
    line-height: 1.4;
    color: #444;
  }

  .btn {
    border-radius: 30px;
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
  }

  .modal-image {
    width: 100%;
    height: 80vh;
    border-radius: 1rem;
    box-shadow: 0 0 10px rgba(255,255,255,0.2);
  }

  .custom-modal-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    z-index: 9999;
    overflow-y: auto;
    animation: fadeIn 0.3s ease-in-out;
  }

  .custom-modal-content {
    backdrop-filter: blur(20px);
    background-color: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 2rem;
    border-radius: 1rem;
    max-width: 900px;
    width: 100%;
    text-align: center;
  }

  .btn-close-white {
    filter: invert(1);
    background-color: white;
    border-radius: 50%;
    width: 32px;
    height: 32px;
  }

  .form-select, .form-control {
    border-radius: 30px;
    padding: 0.5rem 2rem;
    font-size: 0.875rem;
  }

  @keyframes fadeIn {
    0% { opacity: 0; transform: scale(0.95); }
    100% { opacity: 1; transform: scale(1); }
  }

  @media (max-width: 576px) {
    .cert-img-wrapper embed,
    .cert-img-wrapper img {
      max-height: 160px;
    }

    .modal-image {
      height: 70vh;
    }

    .custom-modal-content {
      max-width: 95vw;
      padding: 1rem;
    }

    .card-body h5 {
      font-size: 1rem;
    }

    .card-body p {
      font-size: 0.8rem;
    }
  }
`}</style>



    </main>
  );
};

export default CertificatesMain;
